import 'idempotent-babel-polyfill'

import Vue from 'vue'
import vuetify from './plugins/vuetify'
import Highcharts from 'highcharts'
import ExportDataModule from 'highcharts/modules/export-data'
import Exporting from 'highcharts/modules/exporting'
import HighchartsVue from 'highcharts-vue'
import VueClickOutside from 'vue-click-outside'
import './plugins/translation'

import ApiCall from './utils/api-call'
import App from './App.vue'
import router from './router'
import store from './store'

import InputFields from '@/pages/consultation/details/components/input-fields'
import OutputCategory from '@/pages/consultation/details/components/output-category'
import OutputFields from '@/pages/consultation/details/components/output-fields'
import NConfirmDialog from '@/components/common/n-confirm-dialog'
import NDeleteDialog from '@/components/common/n-delete-dialog'
import NDatePicker from '@/components/common/n-date-picker'
import NErrorTooltip from '@/components/common/n-error-tooltip'
import NInfoTooltip from '@/components/common/n-info-tooltip'
import NRadio from '@/components/common/n-radio'

import './utils/toast'
import 'vuetify/src/styles/main.sass'
import '@/assets/sass/main.scss'

Exporting(Highcharts)
ExportDataModule(Highcharts)
Vue.use(HighchartsVue, {
  highcharts: Highcharts
})

Vue.config.productionTip = false
Vue.prototype.$axios = ApiCall

Vue.component('input-fields', InputFields)
Vue.component('output-category', OutputCategory)
Vue.component('output-fields', OutputFields)
Vue.component('n-confirm-dialog', NConfirmDialog)
Vue.component('n-delete-dialog', NDeleteDialog)
Vue.component('n-date-picker', NDatePicker)
Vue.component('n-error-tooltip', NErrorTooltip)
Vue.component('n-info-tooltip', NInfoTooltip)
Vue.component('n-radio', NRadio)

Vue.directive('v-click-outside', VueClickOutside)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
